exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accessory-card .multiselect {\n  width: auto;\n}\n.accessory-card .multiselect__select {\n  width: 26px;\n}\n.accessory-card .multiselect__option--highlight {\n  background: #51007a;\n  outline: none;\n  color: #fff;\n}\n.accessory-card .multiselect__option--selected.multiselect__option--highlight {\n  background: #f3f3f3;\n  color: #35495e;\n  cursor: default;\n}", ""]);

// exports
